import {Component, Input, OnInit} from '@angular/core';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {EmployeeDesignationService} from '../../../../shared/service/employee-designation.service';
import {EmployeeDesignationDTO} from '../../../../shared/dto/employee-designation.model';
import swal from "sweetalert2";
import {EmployeeDTO} from '../../../../shared/dto/employee.model';
import {EmployeeService} from '../../../../shared/service/employee.service';
import {TokenStorageService} from '../../../../shared/service/token-storage.service';
import {PatternValidation} from '../../../../shared/enums/pattern-validation.enum';
import {Router} from '@angular/router';

@Component({
  selector: 'app-employee-popup',
  templateUrl: './employee-popup.component.html',
  styleUrls: ['./employee-popup.component.scss']
})
export class EmployeePopupComponent implements OnInit {
  @Input() employeeMgtCopy_: EmployeeDTO;
  @Input() employeeDesignation: string;

  employeeMgt: any;
  public employeePopup: FormGroup;
  public selectedState: string;
  public identificationNo: string;
  public address: string;
  public contactNo1: string;
  public contactNo2: string;
  public name: string;
  public email: string;
  public selectedMode;
  public id: number;
  public href: string = "";
  public nicIsExist:boolean = false;
  public emailIsExist: boolean = false;
  public designation: string;

  public employeeDesignationDTOS: EmployeeDesignationDTO [] = [];

  ActionMode = ActionMode;
  constructor(public activeModal: NgbActiveModal,
              private employeeDesignationService :EmployeeDesignationService,
              private employeeService : EmployeeService,
              private tokenStorageService: TokenStorageService,
              private router : Router) {
    console.log(this.employeeDesignation)
  }

  ngOnInit() {
    this.loadEmployeeDesignations();
    this.nicIsExist = true;
    this.emailIsExist = true;
    this.employeePopup = new FormGroup({
      name: new FormControl(null,Validators.required),
      identificationNo: new FormControl(null,[Validators.required , Validators.pattern(PatternValidation.nicValidation)]),
      address: new FormControl(null,Validators.required),
      contactNo1: new FormControl(null,[Validators.required , Validators.pattern(PatternValidation.contactNumberValidation)]),
      contactNo2: new FormControl(null),
      designation: new FormControl(null,Validators.required),
      email: new FormControl(null,[Validators.required , Validators.pattern(PatternValidation.emailValidation)]),
      states: new FormControl(null,Validators.required),
    });

    this.href = this.router.url;

    this.employeeMgt =  {...this.employeeMgtCopy_};
    if (this.selectedMode === ActionMode.VIEW) {
      this.employeePopup.disable();
    }


  }

  loadEmployeeDesignations() {
    this.employeeDesignationService.getAllEmployeeDesignation().subscribe(
      (data : EmployeeDesignationDTO []) => {
        this.employeeDesignationDTOS = data;
      }
    )
  }

  onSubmit(){
    let isValid: boolean = true;
    let errorMessage: string = '';

    if (!this.employeePopup.valid) {
      isValid = false;
      errorMessage = 'Please, Fill the form Data...!'
    }
    if (isValid) {
      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result) => {
        if(result.value) {
          const employeeDTO: EmployeeDTO = new EmployeeDTO(
            this.id,
            this.name,
            this.identificationNo,
            this.address,
            this.contactNo1,
            this.contactNo2,
            this.email,
            this.selectedState,
            this.designation,
            null,
            this.tokenStorageService.getUserObjectToken().username,
            this.href
          );
          this.employeeService.saveEmployeeDetails(employeeDTO).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.activeModal.close("Saved");
            }
          );
        }
        }, reason => {
        }
      );
    } else{
      swal.fire('Error',errorMessage,'error');
    }
  }

  get FormControls() {
    return this.employeePopup.controls;
  }

  validateUserNIC(){
    this.employeeService.checkNICIfExist(this.employeePopup.value.identificationNo).subscribe(
      (data: boolean) =>{
        if(data === true) {
          this.nicIsExist = false;
        }else {
          this.nicIsExist = true;
        }
      }
    );
  }

  ValidateUserEmail() {
    this.employeeService.checkEmailIfExist(this.employeePopup.value.email).subscribe(
      (data: boolean) => {
        if(data === true) {
          this.emailIsExist = false;
        }else{
          this.emailIsExist = true;
        }
      }
    );
  }

}
